import React, { useEffect, useState } from 'react';
import Header from '../../../common/Header/Header';
import { connect } from 'react-redux';
import { convertDateInFormat, convertDateToLocalDatetime, getQueryData } from '../../../../utils';
import ErrorAlert from '../../../common/Alert/ErrorAlert';
import SuccessAlert from '../../../common/Alert/SuccessAlert';
import $ from 'jquery';

const DeleteSkilltestAttempt = ({ csrf }) => {
    const [quizData, setQuizData] = useState(null);
    const [quizId, setQuizId] = useState(null);
    const [selectedQuizTitle, setSelectedQuizTitle] = useState("");
    const [email, setEmail] = useState("");
    const [lastAttemptData, setLastAttemptData] = useState(null);
    const [showDeleteBtn, setShowDeleteBtn] = useState(false);
    const [attemptId, setAttemptId] = useState(null);

    const [iserror, setIsError] = useState(false);
    const [issuccess, setIsSuccess] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(()=>{
        if(csrf){
            const formData = new FormData();
            formData.append("platform", 'quizmania');
            formData.append("url", 'attempts/get-all-quiz');
            formData.append("forward_user_data", "True");
            formData.append("method","GET");
            formData.append("timeout", 100);

            fetch(process.env.REACT_APP_ELEVATE_USER_REST_URL, {
                method: 'POST',
                body:formData,
                headers: {
                    "X-CSRFToken":csrf,
                },
                credentials:process.env.REACT_APP_CREDENTIAL_TYPE
            })
            .then(response => {
                return response.json();
            })
            .then(result => {
                setQuizData(result?.response?.data);
            })
            .catch(error => {
                console.log(error);
            });
        }
    },[csrf])

    useEffect(()=>{
      setShowDeleteBtn(false);
      setLastAttemptData(null);
      setAttemptId(null);
    },[email,selectedQuizTitle]);

    const resetFormFields = () => {
        setSelectedQuizTitle("");
        setQuizId(null);
        document.getElementById("quizIdValue").value = null;
        setEmail("");
        setAttemptId(null);
    }

    const handleQuizChange = (event) => {
        if (quizData.some((quiz) => {
            if (quiz.quiz_id === event.target.value) {
                setSelectedQuizTitle(quiz.title);
            }
            return quiz.quiz_id === event.target.value;
        })) {
            setQuizId(event.target.value);
        } else {
            setQuizId(null);
            setSelectedQuizTitle("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        $('#csvGenerateBtn').addClass('d-none');
        $('#generatingBtn').removeClass('d-none');

        if(!attemptId) {
            setMessage("Please select the attempt to delete.");
            setIsError(true);
            setTimeout(() => {
                setIsError(false);
            }, 3000);
            $('#csvGenerateBtn').removeClass('d-none');
            $('#generatingBtn').addClass('d-none');
            return false;
        }

        let payload = {
            "quiz_id" : quizId,
            "email" : email,
            "user_quiz_attempt_id" : attemptId
        }

        const formData = new FormData();
        formData.append("platform", 'quizmania');
        formData.append("payload", JSON.stringify(payload));
        formData.append("url", 'attempts/delete-last-attempt/');
        formData.append("forward_user_data", "True");

        fetch(process.env.REACT_APP_ELEVATE_USER_REST_URL, {
            method: 'POST',
            body:formData,
            headers: {
                "X-CSRFToken":csrf,
            },
            credentials:process.env.REACT_APP_CREDENTIAL_TYPE
        })
        .then(response => {
            $('#csvGenerateBtn').removeClass('d-none');
            $('#generatingBtn').addClass('d-none');
            return response.json();
        })
        .then(result => {
          console.log("Result",result)
            if(result?.response?.status_code === 200){
                setMessage(result?.response?.message);
                setIsSuccess(true);
                setTimeout(() => {
                    setIsSuccess(false);
                }, 3000);
                resetFormFields();
            }
            else{
                setMessage(result?.response?.message);
                setIsError(true);
                setTimeout(() => {
                    setIsError(false);
                }, 3000);
                return false;
            }
        })
        .catch(error => {
            $('#csvGenerateBtn').removeClass('d-none');
            $('#generatingBtn').addClass('d-none');
            setMessage(error.message);
            setIsError(true);
            setTimeout(() => {
                setIsError(false);
            }, 3000);
            return false;
        });

    }

    const getLastAttempt = (e) => {
      e.preventDefault();
      $('#fetchAttemptDetailsBtn').addClass('d-none');
      $('#fetchingAttemptDetailsBtn').removeClass('d-none');
      if(csrf && email && selectedQuizTitle){
        const formData = new FormData();
        formData.append("platform", 'quizmania');
        formData.append("url", `attempts/get-last-attempt/?quiz_id=${quizId}&email=${email}`);
        formData.append("forward_user_data", "True");
        formData.append("method","GET");

        fetch(process.env.REACT_APP_ELEVATE_USER_REST_URL, {
          method: 'POST',
          body:formData,
          headers: {
              "X-CSRFToken":csrf,
          },
          credentials:process.env.REACT_APP_CREDENTIAL_TYPE
        })
        .then(response => {
          $('#fetchAttemptDetailsBtn').removeClass('d-none');
          $('#fetchingAttemptDetailsBtn').addClass('d-none');
          return response.json();
        })
        .then(result => {
          console.log("Result",result)
            if(result?.response?.status_code === 200){
                setMessage(result?.response?.message);
                setIsSuccess(true);
                setTimeout(() => {
                    setIsSuccess(false);
                }, 3000);
                setLastAttemptData(result?.response?.data);
                setShowDeleteBtn(true);
            }
            else{
                setMessage(result?.response?.message);
                setIsError(true);
                setTimeout(() => {
                    setIsError(false);
                }, 3000);
                return false;
            }
        })
        .catch(error => {
            $('#fetchAttemptDetailsBtn').removeClass('d-none');
            $('#fetchingAttemptDetailsBtn').addClass('d-none');
            setMessage(error.message);
            setIsError(true);
            setTimeout(() => {
                setIsError(false);
            }, 3000);
            return false;
        });
      }
    }

    return (
        <>
            <Header />
            {iserror && <ErrorAlert message={message} setIsError={setIsError} />}
            {issuccess && <SuccessAlert message={message} />}
            <section id='privateRegistration' className='common-style background-dark-primary min-vh-100'>
                <div className='container py-5 px-5'>
                    <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-lg-10'>
                            <div className='card p-4 border-0 shadow background-dark-tertiary'>
                                <div className="card-body">
                                    <h3 className="card-title mb-3 text-center text-white fw-semibold text-uppercase">Delete Skilltest Attempt</h3>
                                    <form className='w-100'>
                                        <div className="form-group mb-3">
                                            <span className=" text-white me-2">Select Quiz <sup className='text-danger'>*</sup></span>
                                            <input id="quizIdValue" list="quizzes" className='form-control' onChange={handleQuizChange} placeholder="Select a Quiz" required autoComplete='off'/>
                                            <datalist id="quizzes">
                                                {quizData && quizData.map((quiz) => (<>
                                                    <option key={quiz.quiz_id} value={quiz.quiz_id}>
                                                        {quiz.title}
                                                    </option>
                                                </>
                                                ))}
                                            </datalist>
                                            {selectedQuizTitle && <p className="text-white pt-2">Selected Quiz Title: <strong>{selectedQuizTitle}</strong></p>}
                                        </div>

                                        <div className="form-group mb-3">
                                            <label className="text-white">Email <sup className='text-danger'>*</sup></label>
                                            <input 
                                            type="email" 
                                            className='form-control' 
                                            placeholder='Email' 
                                            value={email}
                                            onChange={(event)=>setEmail(event.target.value)}
                                            required
                                            />
                                        </div>
                                        {lastAttemptData && <h4 className='text-white pt-4'>Attempt Details: </h4>}
                                        {lastAttemptData?.map((attempt,index) => (
                                            <div class="form-check">
                                                <input class="form-check-input radio-style" type="radio" name="inlineRadioOptions" id={`radio${index}`} value={attempt?.user_quiz_attempt_id}  checked={attemptId === attempt?.user_quiz_attempt_id} onChange={(e)=>setAttemptId(e.target.value)} />
                                                    <label class="form-check-label text-white fs-14 fw-normal" for={`radio${index}`}>
                                                    {attempt?.attempt_number && <p className="text-white">Attempt: <strong>{attempt?.attempt_number}</strong><br/>Score: <strong>{attempt?.score}</strong><br/>Accuracy: <strong>{attempt?.accuracy}</strong><br/>Start Time: <strong>{convertDateInFormat(convertDateToLocalDatetime(attempt?.start_time),"DD MMM YYYY")} • {convertDateInFormat(convertDateToLocalDatetime(attempt?.start_time),"hh:mm A")}</strong><br/>End Time: <strong>{convertDateInFormat(convertDateToLocalDatetime(attempt?.end_time),"DD MMM YYYY")} • {convertDateInFormat(convertDateToLocalDatetime(attempt?.end_time),"hh:mm A")}</strong></p>}
                                                    </label>
                                            </div>
                                        ))}

                                        {showDeleteBtn && <button type="submit" id='csvGenerateBtn' className='btn btn-dark btn-dark-primary px-5 py-2 mt-3 text-uppercase fw-bold w-100' onClick={handleSubmit}>
                                            Delete Attempt
                                        </button>}
                                        <button id='generatingBtn' className='btn btn-dark btn-dark-primary px-5 py-2 mt-3 text-uppercase fw-bold w-100 d-none' disabled>
                                            Deleting Attempt...
                                        </button>
                                        {!showDeleteBtn &&<button id='fetchAttemptDetailsBtn' className='btn btn-dark btn-dark-primary px-5 py-2 mt-3 text-uppercase fw-bold w-100' onClick={getLastAttempt}>
                                            Fetch Attempt Details
                                        </button>}
                                        <button id='fetchingAttemptDetailsBtn' className='btn btn-dark btn-dark-primary px-5 py-2 mt-3 text-uppercase fw-bold w-100 d-none' disabled>
                                            Fetching Attempt Details...
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapStateToProps = (state) => ({
    csrf: state.LoginModalReducer.csrf,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSkilltestAttempt);